export default __webpack_public_path__ + "static/media/186.b6069452.gif";